import { useNavigate } from 'react-router-dom';
import { Button } from '@/src/shadComponents/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function PageNotFound() {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
            <p className="text-7xl font-extrabold tracking-tighter text-muted-foreground/20">404</p>
            <h1 className="mt-4 text-xl font-bold tracking-tight text-foreground">
                Page not found
            </h1>
            <p className="mt-2 text-sm leading-6 text-muted-foreground">
                The page you're looking for doesn't exist or has been moved.
            </p>
            <Button
                variant="outline"
                className="mt-6"
                onClick={() => navigate('/home')}
            >
                <ArrowLeft className="mr-2 size-4" />
                Back to Dashboard
            </Button>
        </div>
    );
}
